"use client";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Por from "./pages/Por";
import Voco from "./pages/Voco";
import ProjectRedirect from "./pages/ProjectRedirect";
import { hostProject, isProduction } from "./components/lib/site";
import './App.css'

const pages = {
  por: <Por />,
  voco: <Voco />,
};

const App = () => {
  const project = hostProject();
  if (project) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={pages[project]} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {Object.keys(pages).map((name) => (
          <Route
            key={name}
            path={`/${name}/*`}
            element={isProduction() ? <ProjectRedirect project={name} /> : pages[name]}
          />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
